import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  GET_OA_AMOUNTS,
  GET_DASHBOARD_AMOUNTS,
  DATA_INIT,
  SET_MAIN_VIEW
} from '../actions';

import {
  CUT,
  HOLD,
  QUEUED,
  PACKED,
  PRINT_READY,
  PRINTED,
  SHIPMENTS,
  PACKING
} from '../status-types';

export const initialDashboardAmountsState = [
  { amount: 0, status: HOLD, amountIcon: 'fa-pause', statusIcon: 'fa-file-photo-o', color: 'card-danger', url: '/dashboard/hold/all', text: `ON_HOLD` },
  { amount: 0, status: QUEUED, amountIcon: 'fa-forward', statusIcon: 'icon-layers', color: 'card-warning', url: '/dashboard/batches/queued', text: 'QUEUED' },
  { amount: 0, status: PRINT_READY, amountIcon: 'fa-clone', statusIcon: 'icon-layers', color: 'card-magenta', url: '/dashboard/batches/printready', text: 'PRINT_READY' },
  { amount: 0, status: PRINTED, amountIcon: 'fa-file-image-o', statusIcon: 'fa-file-photo-o', color: 'card-primary', url: '/dashboard/jobs/printed', text: 'PRINTED' },
  { amount: 0, status: SHIPMENTS, amountIcon: 'fa-truck', statusIcon: 'fa-shopping-cart', color: 'card-midnight', url: '/dashboard/shipping/all', text: 'SHIPMENTS' }
];

export const initialOAAmountsState = [
  { amount: 0, status: HOLD, amountIcon: 'fa-pause', statusIcon: 'fa-file-photo-o', color: 'card-danger', url: '/oa/dashboard/hold/all', text: 'ON_HOLD' },
  { amount: 0, status: QUEUED, amountIcon: 'fa-forward', statusIcon: 'icon-layers', color: 'card-warning', url: '/oa/dashboard/batches/all', text: 'QUEUED' },
  { amount: 0, status: CUT, amountIcon: 'fa-cut', statusIcon: 'fa-file-photo-o', color: 'card-purple', url: '/oa/dashboard/jobs/cut', text: 'CUT' },
  { amount: 0, status: PACKED, amountIcon: 'fa-box', statusIcon: 'fa-file-photo-o', color: 'card-magenta', url: '/oa/dashboard/jobs/packed', text: 'PACKED' },
  { amount: 0, status: PACKING, amountIcon: 'fa-box', statusIcon: 'fa-file-photo-o', color: 'card-magenta', url: '/oa/dashboard/jobs/packing', text: 'PACKING' },
  { amount: 0, status: SHIPMENTS, amountIcon: 'fa-truck', statusIcon: 'fa-shopping-cart', color: 'card-midnight', url: '/oa/dashboard/shipping/all', text: 'SHIPMENTS' }
];

export const initialMainViewState = {
  dashboardSwitch  : <boolean>false,
  dataInit         : <boolean>false,
  eodProcessing    : <boolean>false,
  loggingOut       : <boolean>false,
  printingInvoice  : <boolean>false,
  rtsJobs          : <number>0,
  lateJobs         : <number>0,
  dueTodayJobs     : <number>0,
  process          : <string>'',
  horizon          : <string>'',
  horizonLoading   : <boolean>false,
  networkConnected : <boolean>true
}

export function dashboardAmountsReducer(state = initialDashboardAmountsState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return initialDashboardAmountsState;
    case GET_DASHBOARD_AMOUNTS:
      return state.map((item, index) => {
        return Object.assign({}, item, {
          amount: action.payload.dashboardAmounts[index]
        });
      });
    default:
      return state;
  }
}

export function oaAmountsReducer(state = initialOAAmountsState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return initialOAAmountsState;
    case GET_OA_AMOUNTS:
      return state.map((item, index) => {
        return Object.assign({}, item, {
          amount: action.payload.OAAmounts[index]
        })
      });
    default:
      return state;
  }
}

export function mainViewReducer(state = initialMainViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, {
        dataInit  : false
      });
    case DATA_INIT:
      return Object.assign({}, state, { dataInit: true });
    case SET_MAIN_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const mainViewReducers = combineReducers({
  oaAmounts: oaAmountsReducer,
  dashboardAmounts: dashboardAmountsReducer,
  mainView: mainViewReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/main.ts